import { Scroll } from 'component/Scroll'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { ItemCard } from 'page/StartScreen/combine/item/ItemCard'
import css from 'page/StartScreen/combine/item/ItemsLine.module.scss'
import { store } from 'store/store'

export const ItemsLine = observer(() => {
  const item = store.tempComboItem || store.item!
  const rec = item.rec
  const { items, index } = rec

  return (
    <Space className={css.root} tall wide top>
      <Scroll>
        <Space gap={8} wide top>
          {items.map((item, i) => (
            <ItemCard key={i} item={item} active={index === i} index={i} />
          ))}
        </Space>
      </Scroll>
    </Space>
  )
})
